import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["className", "clsPrefix", "value", "onChange", "placeholder", "split", "onBlur", "onFocus"];

var _dec, _class, _class2, _temp;

import "core-js/modules/es6.regexp.split.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputNumber from './InputNumber';
import { WebUI } from "../../wui-core/src/index.js";

var noop = function noop() {};

var propsTypes = {
  clsPrefix: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.array,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.array,
  max: PropTypes.number,
  min: PropTypes.number,
  step: PropTypes.number,
  precision: PropTypes.number,
  format: PropTypes.func,
  delay: PropTypes.number,
  disabled: PropTypes.bool,
  toThousands: PropTypes.bool,
  toNumber: PropTypes.bool
};
var defaultProps = {
  clsPrefix: 'u-input-number',
  className: '',
  value: [],
  placeholder: [],
  onChange: noop,
  onBlur: noop,
  onFocus: noop
};
var InputNumberGroup = (_dec = WebUI({
  name: "input-number",
  defaultProps: defaultProps
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(InputNumberGroup, _Component);

  var _super = _createSuper(InputNumberGroup);

  function InputNumberGroup(props) {
    var _this;

    _classCallCheck(this, InputNumberGroup);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChange", function (index, v) {
      var value = _this.state.value;
      value[index] = v;

      _this.setState({
        value: value
      });

      _this.props.onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function (index, v) {
      var value = _this.state.value;
      value[index] = v;

      _this.setState({
        value: value
      });

      _this.props.onFocus(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (index, v) {
      var value = _this.state.value;

      if (index == 1) {
        if (v < value[0]) {
          console.warn('The second value must be greater than or equal to the first value');
        }
      }

      value[index] = v;

      _this.setState({
        value: value
      });

      _this.props.onBlur(value);
    });

    _this.state = {
      value: props.value || []
    };
    return _this;
  }

  _createClass(InputNumberGroup, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('value' in nextProps) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          clsPrefix = _this$props.clsPrefix,
          value = _this$props.value,
          onChange = _this$props.onChange,
          placeholder = _this$props.placeholder,
          split = _this$props.split,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          other = _objectWithoutProperties(_this$props, _excluded);

      var stateValue = this.state.value;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-group ").concat(className)
      }, /*#__PURE__*/React.createElement(InputNumber, _extends({
        onChange: function onChange(value) {
          _this2.onChange(0, value);
        },
        onBlur: function onBlur(value) {
          _this2.onBlur(0, value);
        },
        onFocus: function onFocus(value) {
          _this2.onFocus(0, value);
        },
        value: stateValue[0],
        placeholder: placeholder[0]
      }, other)), split ? split : /*#__PURE__*/React.createElement("span", {
        className: "".concat(clsPrefix, "-group-split")
      }, "~"), /*#__PURE__*/React.createElement(InputNumber, _extends({
        onChange: function onChange(value) {
          _this2.onChange(1, value);
        },
        onBlur: function onBlur(value) {
          _this2.onBlur(1, value);
        },
        onFocus: function onFocus(value) {
          _this2.onFocus(1, value);
        },
        value: stateValue[1],
        placeholder: placeholder[1]
      }, other)));
    }
  }]);

  return InputNumberGroup;
}(Component), _defineProperty(_class2, "displayName", 'InputNumberGroup'), _temp)) || _class);
InputNumberGroup.propsTypes = propsTypes;
export default InputNumberGroup;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-input-number/src/InputNumberGroup.js